import { useRecoilValue } from "recoil";
import { ProductTableItemProps } from "../../cart-table-line/components/ProductTableItem";
import { orderLineCount } from "../../cart/miscellaneous/orderLineCount";
import { v4 } from "../../common/miscellaneous/v4";
import { CartAndOrder, orderAtom } from "../miscellaneous/orderAtom";

export type UseOrderValueData =
  | { readonly tag: "ready"; readonly data: CartAndOrder }
  | { readonly tag: "initializing"; readonly data: Partial<CartAndOrder> };

// eslint-disable-next-line functional/immutable-data
const orderLinesLoading: readonly ProductTableItemProps["item"][] = Array<
  ProductTableItemProps["item"]
>(1)
  .fill({})
  .map(() => {
    return {
      manufacturerPartNumber: "-----------------",
      quantity: 99,
      isSample: false,
      orderLineId: v4(),
      partId: 9999999,
      digiKeyPartNumber: "------------------",
      description:
        "------------------------------------------------------------",
      catalogDescription: "------------------------",
      packageType: "----------",
      breakQuantity: 1,
      unitPrice: "111111",
      extendedPrice: "1111",
      unitCost: "111",
    };
  });

const orderLoading: CartAndOrder = {
  orderNumber: undefined,
  status: "Open",
  shippingInformation: {
    shippingAddress: {
      city: "-------",
      companyName: "---------------",
      countryIso: undefined,
      line1: "-----------------",
      postalCode: "-----",
      state: "OR",
    },
  },
  paymentInformation: {
    billingAddress: {
      city: "-------",
      companyName: "-------------",
      countryIso: "US",
      line1: "----------------",
      postalCode: "-----",
      state: "OR",
    },
    paymentOption: { methodName: "--------------" },
    cardLastFour: "------",
    cardExpirationDate: "--------",
    paymentDescription: "--------",
  },
  customerInformation: {
    email: "---------------",
    phoneNumber: "----------",
    hasAcceptedDataTransfer: true,
    hasAcceptedTOS: true,
    hasSamplesAgreement: true,
  },
  orderSummary: {
    subTotal: undefined,
    shippingCost: 0,
    taxCost: 0,
    total: 0,
  },
} as const;

export function useOrderValueData(): UseOrderValueData {
  const orderValue = useRecoilValue(orderAtom);

  return orderValue === "initializing"
    ? {
      tag: "initializing",
      data: {
        ...orderLoading,
        orderLines: orderLinesLoading.slice(0, orderLineCount()),
      },
    }
    : {
      tag: "ready",
      data: orderValue,
    };
}
